import { en } from 'vuetify/lib/locale';

export default {
    ...en
}